<template>
  <div class="page-outbox" v-if="goodsDetailInfo.code">
  	<!--搜索框-->
  	<div class="search-group-wapper">
  		<search-block @searchSub='searchSub' ref="searchBlock"></search-block>
  	</div>
  	<!--详情内容-->
  	<div class="page-center-block">
  		<!--图片-->
	  	<img class="goods-detail-img" :src="goodsDetailInfo.img_url"/>
	  	<!--属性介绍-->
	  	<section class="goods-attr-block">
	  		<h3 class="goods-name">{{goodsDetailInfo.cn_name}}</h3>
	  		<p class="goods-attr">{{goodsDetailInfo.en_name}}</p>
	  		<p class="goods-attr red" v-if="goodsDetailInfo.price&&goodsDetailInfo.price.length>1">￥{{goodsDetailInfo.price[0].price}}-￥{{goodsDetailInfo.price[1].price}}</p>
	  		<p class="goods-attr">产品项目编号：{{goodsDetailInfo.code}}</p>
	  		<p class="goods-attr blue">CAS号：{{goodsDetailInfo.cas}}</p>
	  		<p class="goods-attr blue">浓度级别：{{goodsDetailInfo.level}}</p>
			<p>
        		<label v-if="goodsDetailInfo.if_explode" class="goods-warning"><span>易制爆</span></label>
				<label v-if="goodsDetailInfo.if_drag" class="goods-warning"><span>易制毒</span></label>
      		</p>
	  	</section>
	  	<!--购买信息-->
	  	<section class="goods-saleAttr-block">
	  		<div class="goods-saleAttr-item" v-if="goodsDetailInfo.price">
	  			<label class="goods-saleAttr-key">货号</label>
	  			<div class="goods-saleAttr-val">
	  				<span class="goods-size-item" v-for="(item,index) in goodsDetailInfo.price"
	  					 :class="{'active':curGoodsIndex==index}" @click="selecteGoodsSize(index)">{{item.p_code}}
	  					<i class="goods-size-tag" v-if="item.if_promotion">促</i>
	  				</span>
	  			</div>
	  		</div>
			<div class="goods-salAttr-groups" v-if="goodsDetailInfo.price" v-for="(item,index) in goodsDetailInfo.price" v-show="curGoodsIndex==index">
				<div class="goods-saleAttr-item">
	  				<label class="goods-saleAttr-key">折扣价</label>
					<div class="goods-saleAttr-val">
						<span class="goods-discount">￥{{item.price}}</span>
						<span class="goods-orPrice" v-if="item.if_promotion">￥{{item.market_price}}</span>
					</div>
	  			</div>
				<div class="goods-saleAttr-item">
	  				<label class="goods-saleAttr-key">库存</label>
					<div class="goods-saleAttr-val">
						<span class="goods-store">{{item.stock}}</span>
					</div>
	  			</div>
	  			<div class="goods-saleAttr-item">
					<label class="goods-saleAttr-key">数量</label>
					<div class="goods-saleAttr-val no-border">
						<div class="number-group">
							<button class="minus-btn" :class="{'disabled':selectedCount==1}" @click="minusNum">-</button>
							<mt-field :disableClear="true" placeholder="" type="number" v-model="selectedCount" @change="changeNum(item.maxNum)"></mt-field>
							<button class="add-btn" :class="{'disabled':selectedCount>=item.maxNum}" @click="addNum(item.maxNum)">+</button>
						</div>

					</div>
				</div>
			</div>

	  	</section>
  	</div>

  	<!--提交栏-->
  	<div class="submit-bar">
  		<p class="total-price">总价:<span>￥{{totalPrice}}</span></p>
  		<p class="price-tips">不含运费</p>
  		<button v-if="!goodsDetailInfo.if_explode && !goodsDetailInfo.if_drag" class="submit-btn" id="addToShopbag" @click="addToShopbag">加入购物车</button>
		<label v-if="goodsDetailInfo.if_explode || goodsDetailInfo.if_drag" class="goods-warning"><span>请联系客服购买！</span></label>
  	</div>
		<!--飞入商品元素-->
		<div id="flyItem" class="fly_item">+{{selectedCount}}</div>
  </div>
</template>

<script>
	import SearchBlock from 'basic/searchBlock/searchBlock'
	export default {
	name: 'goodsDetail',
	    data () {
	      return {
	      	selectedCount:1,
	      	curGoodsIndex:0,
	      	goodsDetailInfo:{

	      	}
	      }
	    },
	    computed:{
	    	totalPrice(){
	    		if(this.goodsDetailInfo.price){
	    			var curGoods=this.goodsDetailInfo.price[this.curGoodsIndex];
		    		var curPrice=curGoods.price?curGoods.price:curGoods.market_price;
		    		return curPrice*this.selectedCount;
		    	}else{
		    		return 0;
		    	}

	    	}
	    },
	    mounted(){
				if(this.$route.meta&&this.$route.meta.pageBelong){
					this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
				}
				this.getDetail();
			},
	    methods:{
	    	searchSub(keyWord){
	    		this.$router.push({path:'/GoodsList/'+keyWord})
	    	},
	    	selecteGoodsSize(index){
	    		this.curGoodsIndex=index;
	    		this.selectedCount=1;
	    	},
	    	minusNum(){
	    		if(this.selectedCount==1) return;
	    		this.selectedCount=this.selectedCount-1;
	    	},
	    	addNum(maxNum){
	    		if(this.selectedCount==maxNum) return;
	    		this.selectedCount=this.selectedCount+1;
	    	},
	    	changeNum(maxNum){
	    		if(this.selectedCount<1){
	    			this.selectedCount=1;
	    		}else if(this.selectedCount>maxNum){
	    			this.selectedCount=maxNum;
	    		}
	    	},
	    	addToShopbag(){
	    		var that=this;
	    		var tempCount=this.$store.state.shopCount;
	    		if(!this.goodsDetailInfo.price||!this.goodsDetailInfo.price[this.curGoodsIndex]) {
	    		  this.$toast('请选择货号！');
	    		  return;
          }
          if(!this.$store.state.userInfo.user_id){
	    		  //先登录
            this.$router.push('/Login?backRoute='+this.$route.path);
            return;
          }
	    		//加入购物车
          this.$cHttp.post('shopcart/add',{
            partner:this.$systemConfig.partner,
            apikey:this.$systemConfig.apikey,
            user_id:this.$store.state.userInfo.user_id,
            pid:this.goodsDetailInfo.price[this.curGoodsIndex].pid,
            num:this.selectedCount
          }).then((res)=>{
            if(res.status&&res.status==1){
              console.log(res)
              tempCount=res.data.total_num;
              that.$store.commit('setShopCount', tempCount);
            }else{
              this.$toast(res.error_msg)
            }

          }).catch((msg)=>{
            this.$toast(msg);
          })
					// 抛物线运动
          var eleFlyElement = document.querySelector("#flyItem");
          var eleShopCart = document.querySelector("#shopCart");
          var myParabola = funParabola(eleFlyElement, eleShopCart, {
            speed: 80, //抛物线速度
            curvature: 0.0068, //控制抛物线弧度
            complete: function () {
              eleFlyElement.style.visibility = "hidden";
              that.$store.commit('setShopCount', tempCount);
            }
          });
          var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft || 0,
            scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
          eleFlyElement.style.left = event.clientX + scrollLeft + "px";
          eleFlyElement.style.top = event.clientY + scrollTop + "px";
          eleFlyElement.style.visibility = "visible";
          // 需要重定位
          myParabola.position().move();

		    },
		    getDetail(){
		    	this.$cHttp.post('products/price',{
	      	partner:this.$systemConfig.partner,
	      	apikey:this.$systemConfig.apikey,
	      	id:this.$route.params.goodsId
	      	}).then((res)=>{
	      			console.log(res)
	      			if(res.status&&res.status==1){
				      	this.goodsDetailInfo=res.data;
				      	console.log(this.goodsDetailInfo)
	      			}else{
	      				this.$toast('暂无数据')
	      			}
	      	}).catch((msg)=>{
	      		this.$toast(msg)
	      	})
		    }
	    },
	    components:{
	        SearchBlock
	    }
	}
</script>

<style>
	.mint-cell{
		min-height: auto;
		min-width: .4rem;
	}
	.mint-field-core{
		max-width: .4rem;
		text-align: center;
	}
	.mint-cell-wrapper{
		padding: 0;
	}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.fly_item{
		overflow:hidden;
		position:fixed;
		visibility:hidden;
		opacity:.8;
		filter:alpha(opacity=80);
		color: $mainColor;
		font-size: 20px;
		font-weight:bold;
		z-index: 1000;
	}
	.search-group-wapper{
		position: absolute;
		top:0;
	    left:0;
	    width: 100%;
	}
	.page-center-block{
		position: absolute;
		width: 100%;
		top:.61rem;;
		left:0;
		bottom:.45rem;
	    overflow: auto;
		.goods-detail-img{
			padding:.1rem;
			width: 100%;
			box-sizing: border-box;
		}
		.goods-attr-block{
			margin: 0 .1rem;
			padding: .1rem;
			font-size: .15rem;
			line-height: .25rem;
			color: #666;
			border-top: 1px solid #e5e5e5;
			.goods-name{
				color: #000;
			}
			.goods-attr{
				&.red{
					color: $mainColor;
				}
				&.blue{
					color: #26A2FF;
				}
			}
		}
		.goods-saleAttr-block{
			margin-top: .1rem;
			border-top: 1px solid #ccc;
			.goods-saleAttr-item{
				display: flex;
				padding-left: .2rem;
				font-size: .15rem;
				line-height: .25rem;
				box-sizing: border-box;
				.goods-saleAttr-key{
					padding: .08rem 0;
					min-width: .6rem;
					color: #999;
				}
				.goods-saleAttr-val{
					flex: 1;
					padding: .08rem 0;
					padding-right: .1rem;
					border-bottom: 1px solid #e5e5e5;
					&.no-border{
						border:none;
					}
					.goods-size-item{
						position:relative;
						display: inline-block;
						vertical-align: top;
						margin: .04rem 0;
						margin-right: .08rem;
						padding: 0 .06rem;
						padding-right: .15rem;
						font-size:.13rem;
						line-height: .35rem;
						height: .35rem;
						border: 1px solid #eee;
						border-radius: .04rem;
						background-color: #eee;
						&.active{
							color: #fff;
							border-color: $mainColor;
    						background-color: $mainColor-light2;
						}
						.goods-size-tag{
							position:absolute;
							top:-.05rem;
							right:-.06rem;
							padding: .05rem;
							font-size: .12rem;
							line-height: .12rem;
							color: #fff;
							border-radius: .2rem;
							background-color: $mainColor;
						}
					}
					.goods-discount{
						margin-right: .1rem;
						color: $mainColor;
					}
					.goods-orPrice{
						color: #666;
						text-decoration: line-through;
					}
					.goods-store{

					}
					.number-group{
						width: 1rem;
						display: flex;
						border: 1px solid #ddd;
						border-radius: 5px;;
						.minus-btn,.add-btn{
							padding: 0 .1rem;
							font-size: .18rem;
							border:none;
							background-color: #ddd;
							&:active{
								background-color: #ccc;
							}
							&.disabled{
								background-color:#fff;
								&:active{
									background-color: #fff;
								}
							}
						}
						.minus-btn{
							border-right: 1px solid #ddd;
						}
						.add-btn{
							border-left: 1px solid #ddd;
						}
					}
				}
			}
		}

	}
	.submit-bar{
		display: flex;
		position:fixed;
		bottom: .45rem;
		left:0;
		right:0;
		padding-left: .1rem;
		font-size: .14rem;
		line-height: .45rem;
		border-top: 1px solid #ccc;
		background-color: #fff;
		.total-price{
			>span{
				padding: 0 .08rem;
				color: $mainColor;
			}
		}
		.price-tips{
			flex: 1;
			color: #999;
		}
		.submit-btn{
			padding: 0 .05rem;
			font-size: .14rem;
			color: #fff;
			border:none;
			background-color: #ffb820;
			&:active{
				background-color: #FFA000;
			}
		}
	}

	.goods-warning{
		padding-right: .05rem;
		span{
		color:#FF0000;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/goodsDetail/goodsDetail.vue